export default "__VITE_ASSET__473baaf1__"